import { t, Trans } from '@lingui/macro';
import { NoddiButton, NoddiIcon } from 'noddi-ui-common';
import { ContentWrapper, getLongAddressName, NoddiBasicCard, NoddiLink } from 'noddi-ui-web';
import { customerRoutes } from 'noddi-util';
import { useNavigate } from 'react-router-dom';
import { ProposalSummary } from '../../components/BookingProposal/ProposalSummary';
import { TransparentBottomBar } from '../../components/Layouts/TransparentBottomBar';
import { useBookingProposalAddress, useBookingProposalItems, useBookingProposalSlug } from './bookingProposalStore';

export const BookingProposal = () => {
  const address = useBookingProposalAddress();
  const bookingProposalItems = useBookingProposalItems();
  const slug = useBookingProposalSlug();
  const navigate = useNavigate();

  function handleNavigateNextStep() {
    if (address) {
      navigate(customerRoutes.bookingProposalTimeWindowPicker.getPath({ slug }));
    } else {
      navigate(customerRoutes.bookingProposalAddress.getPath({ slug }));
    }
  }

  return (
    <ContentWrapper
      className='max-w-screen-md'
      hideBackButton
      title={t`Ready for mounting?`}
      subtitle={t`Your tires have arrived safely and we’re ready to get them mounted. All that’s left for you to do is choose the time and location that work best for you. We’ll take care of the rest.`}
    >
      <div className='flex flex-col gap-4'>
        <NoddiBasicCard className='flex flex-col overflow-hidden p-0'>
          <img src='/assets/images/wc.jpg' alt={t`Noddi wheel change`} />

          <div className='flex flex-col gap-4 px-5 pb-3 pt-5'>
            {address && (
              <div className='flex w-full justify-between gap-4'>
                <div className='flex gap-2'>
                  <NoddiIcon name='LocationPin' />
                  <span>{getLongAddressName(address)}</span>
                </div>
                <NoddiLink
                  to={customerRoutes.bookingProposalAddress.getPath({ slug })}
                  variant='secondary'
                  size='small'
                  startIcon='Edit'
                >
                  <Trans>Edit</Trans>
                </NoddiLink>
              </div>
            )}

            <ProposalSummary bookingProposalItems={bookingProposalItems} />
          </div>
        </NoddiBasicCard>
        <TransparentBottomBar className='md:mt-0'>
          <div className='md:flex md:justify-end'>
            <NoddiButton variant='success' className='w-full' endIcon='ArrowRight' onPress={handleNavigateNextStep}>
              {address ? <Trans>Choose time</Trans> : <Trans>Choose time and address</Trans>}
            </NoddiButton>
          </div>
        </TransparentBottomBar>
      </div>
    </ContentWrapper>
  );
};
